import { routes } from '@routes/index'
import { isBrowser } from '@utils/isBrowser'
import redirectService from '@utils/services/redirectServices'

const ACCESS_TOKEN = 'accessToken'

export type ParseTokenPayload = {
  sub: string
  exp: number
}

class TokenService {

  exp:number | null = 0
  sub:string | null = null

  constructor() {
    this.parseToken()
  }

  getEmail(): string | null {
    return this.sub
  }

  isExpired(): boolean {
    return this.exp ? Date.now() > this.exp * 1000 : true
  }

  getToken(): string | null {
    return isBrowser ? localStorage.getItem(ACCESS_TOKEN) : null
  }

  setToken(token: string, maybeDoRedirect = true, redirect?: string) {
    localStorage.setItem(ACCESS_TOKEN, token)
    this.parseToken()
    if (maybeDoRedirect) {
      redirectService.maybeDoRedirect(() => {
        window.location.href = redirect ? redirect : routes.mewoz.home
      })
    }
  }

  removeToken() {
    localStorage.removeItem(ACCESS_TOKEN)
    this.parseToken()
  }

  parseToken() {
    const token = this.getToken()

    try {
      if(!token) throw 'No token found'
  
      const base64 = token
        .split('.')[1]
        .replace(/-/g, '+')
        .replace(/_/g, '/')
  
      const parsed = decodeURIComponent(window.atob(base64).split('').map(c =>
        '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      ).join(''))
  
      const props =  JSON.parse(parsed) as ParseTokenPayload

      this.sub = props.sub
      this.exp = props.exp
    } catch(err) {
      this.sub = null
      this.exp = null
    }
  }
}

export default new TokenService()